// extracted by mini-css-extract-plugin
module.exports = {"tips":"Styles_tips__qA6DA","tips--small":"Styles_tips--small__AcZXl","tips__title":"Styles_tips__title__aZGk5","tips--simple":"Styles_tips--simple__S_eG1"};